import {createStore} from 'devextreme-aspnet-data-nojquery';
import DataSource from 'devextreme/data/data_source';
import useGetToken from './useGetToken';
import {ensureSessionOrRedirect} from '../../helpers/session';

function useLoadCustom(
  url: string,
  key: string | string[],
  params: Object | undefined = undefined,
  allowAdd: boolean = true,
  allowEdit: boolean = true,
  allowDelete: boolean = true,
  customProps: any = null,
) {
  const token = useGetToken();
  const store = createStore({
    key: key,
    loadUrl: url,
    deleteUrl: allowDelete ? url : undefined,
    insertUrl: allowAdd ? url : undefined,
    updateUrl: allowEdit ? url : undefined,
    loadParams: params,
    onBeforeSend: (_, options) => {
      if (!ensureSessionOrRedirect()) {
        (options as any).cancel = true;
        return;
      }
      options.headers = {Authorization: `Bearer ${token}`};
    },
  });
  const dataSource = new DataSource({
    store: store,
    ...customProps,
  });

  return dataSource;
}

export default useLoadCustom;
